import { ReactNode } from 'react'

import { useAppRouter } from '@/shared/lib/router'
import Swal from 'sweetalert2'

import { cn } from '@/shared/lib/utils'

import { CloseButton } from './CloseButton'

interface Challenge {
  name?: string
  [key: string]: any
}

interface HeaderProps {
  id?: string
  challenge?: Challenge
  children?: ReactNode
  onClose?: () => void | Promise<void>
}

export const Header = ({
  id = 'unique',
  challenge,
  children,
  onClose
}: HeaderProps) => {
  const router = useAppRouter()

  const handleBackToJourney = async () => {
    const { isConfirmed } = await Swal.fire({
      icon: 'warning',
      text: 'Se você sair, perderá todo o progresso deste nível. Deseja continuar?',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Sair',
      cancelButtonText: 'Continuar no nível',
      customClass: {
        confirmButton: 'btn btn-light bg-white font-bold text-danger w-full',
        cancelButton: 'btn btn-success font-bold w-full'
      }
    })

    if (isConfirmed) {
      router.push('/jornadas')
    }
  }

  return (
    <div
      id={`level-play-header`}
      className={cn(
        'relative z-20 flex items-center justify-between gap-6 w-[90%] mx-auto p-3 md:p-4 rounded-full',
        'bg-white mt-[-30px]'
      )}
    >
      <div className="absolute right-[-5px] top-[-15px]">
        <CloseButton onClick={() => void (onClose ? onClose() : handleBackToJourney())} />
      </div>

      <div
        className={cn(
          'w-full rounded-full p-2 md:p-3',
          'shadow-[0_5px_0_-1px_#8F85F4,inset_0_4px_0_0_rgba(255,255,255,0.25)]',
          'bg-[linear-gradient(360deg,_#EAEEFF_-12.43%,_#BAC4F0_143.3%)]'
        )}
      >
        <span className="block m-0 font-sans text-md font-bold text-center text-primary md:text-xl">
          {challenge?.name} {children}
        </span>
      </div>
    </div>
  )
}
